import { render, staticRenderFns } from "./images-box.vue?vue&type=template&id=1b6e6333&scoped=true&"
import script from "./images-box.vue?vue&type=script&lang=ts&"
export * from "./images-box.vue?vue&type=script&lang=ts&"
import style0 from "./images-box.vue?vue&type=style&index=0&id=1b6e6333&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6e6333",
  null
  
)

export default component.exports